import React from 'react';

import PageLayout from '@/components/layout/PageLayout';
import { CreateShiftDescriptionForm, ShiftWeeklyDistributionGrid } from '@/components/features/shift';
import { useShiftCreate } from '@/hooks/shift/useShiftCreate';
import { useShiftWeeklyDistribution } from '@/hooks/shift/useShiftWeeklyDistribution';
import { useTranslation } from '@/i18n';


export const ShiftCreate: React.FC = () => {
  const { t: translate } = useTranslation('schedule');
  const {
    formSubset,
    isLoadingCatalogs,
    workingDayTypeOptions,
    workingDayOptions,
    selectedWorkingDay,
    isDistributedCyclesType,
    isExceptionalType,
    isStaticType,
    weeksCountEditable,
    ordinaryHours,
    isGridVisible,
    onGenerate,
    handleCancel,
    confirmNavigation,
  } = useShiftCreate();

  const descriptionValues = formSubset.watch();

  const weeklyDistribution = useShiftWeeklyDistribution({
    descriptionValues,
    selectedWorkingDay,
    ordinaryHours,
    confirmNavigation,
  });

  return (
    <PageLayout isLoading={isLoadingCatalogs} dynamicTitle={translate('shift.create.title')}>
      <div data-testid="shift-create-page">
        <CreateShiftDescriptionForm
          form={formSubset}
          workingDayTypeOptions={workingDayTypeOptions}
          workingDayOptions={workingDayOptions}
          isDistributedCyclesType={isDistributedCyclesType}
          isExceptionalType={isExceptionalType}
          isStaticType={isStaticType}
          weeksCountEditable={weeksCountEditable}
          ordinaryHours={ordinaryHours}
          onGenerate={onGenerate}
          onCancel={handleCancel}
        />

        {isGridVisible && (
          <ShiftWeeklyDistributionGrid
            {...weeklyDistribution}
            onCancel={handleCancel}
          />
        )}
      </div>
    </PageLayout>
  );
};

export default ShiftCreate;
